export default "__VITE_ASSET__CYE2vx$5__"